import React, { useEffect, useRef, useState, useImperativeHandle } from "react";
import moment from "moment/moment";
import { Accordion, Drawer, Card, Textarea, Text, Panel } from "rsuite";
import { Button, Input } from "antd";
import Table from "react-bootstrap/Table";
import { LucideMic, LucideSave } from "lucide-react";

export const NotaEvolucion = ({
  idNegocio,
  idPaciente,
  paciente,
  tituloDrawer,
  response,
  ref,
  onSendData,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const fecha =
    Object.keys(response).length > 0
      ? moment(response.fecha).format("DD-MMM-YYYY")
      : "";
  const dataSignosEx =
    Object.keys(response).length > 0 ? response.dataExplora : [];
  const frecCardiacaEx =
    Object.keys(response).length > 0 ? response.dataSignos.frecCardiaca : "";
  const frecRespEx =
    Object.keys(response).length > 0 ? response.dataSignos.frecResp : "";
  const tempEx =
    Object.keys(response).length > 0 ? response.dataSignos.temp : "";
  const presionArtEx =
    Object.keys(response).length > 0 ? response.dataSignos.presionArt : "";
  const pesoEx =
    Object.keys(response).length > 0 ? response.dataSignos.peso : "";
  const tallaEx =
    Object.keys(response).length > 0 ? response.dataSignos.talla : "";
  const imcEx = Object.keys(response).length > 0 ? response.dataSignos.imc : "";
  const saturaOxEx =
    Object.keys(response).length > 0 ? response.dataSignos.saturaOx : "";
  const glicemiaCapEx =
    Object.keys(response).length > 0 ? response.dataSignos.glicemiaCap : "";
  const otrosDatosExploraEx =
    Object.keys(response).length > 0 ? response.dataSignos.otrosDatosExp : "";
  const [estadoIMCEx, setEstadoIMCEx] = useState("");
  const diagnostico =
    Object.keys(response).length > 0 ? response.diagnostico : "";
  const tratamiento =
    Object.keys(response).length > 0 ? response.tratamiento : "";
  const listaAnteced =
    Object.keys(response).length > 0 ? response.antecedente : [];
  const textoAnterior =
    Object.keys(response).length > 0 ? response.notaEvol : "";

  const [texto, setTexto] = useState("");
  const [escuchando, setEscuchando] = useState(false);
  const { TextArea } = Input;

  const initialized = useRef(false);

  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;
  const recognition = new SpeechRecognition();

  // Configuraciones básicas
  recognition.lang = "es-MX"; // Define el idioma (puedes cambiarlo a 'es-MX', 'en-US', etc.)
  recognition.continuous = true; // Sigue escuchando hasta que se detenga
  recognition.interimResults = true; // Muestra resultados preliminares

  const iniciarEscucha = () => {
    setTexto("");
    setEscuchando(true);
    recognition.start();

    recognition.onresult = (event) => {
      let transcripcion = "";
      for (let i = 0; i < event.results.length; i++) {
        transcripcion += event.results[i][0].transcript;
      }
      setTexto(transcripcion);
    };

    recognition.onerror = (event) => {
      console.error("Error en el reconocimiento:", event.error);
    };
  };

  const detenerEscucha = () => {
    setEscuchando(false);
    recognition.stop();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleSendData = () => {
    onSendData(texto);
    setIsOpen(false);
  };

  useImperativeHandle(
    ref,
    () => ({
      open: () => setIsOpen(true),
      close: () => setIsOpen(false),
      toggle: () => setIsOpen((_) => !_),
    }),
    [],
  );

  return (
    <div>
      <Drawer size="full" open={isOpen} onClose={handleClose}>
        <Drawer.Header>
          <Drawer.Title>
            Nota de Evolución: {paciente}
          </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          {/* *********************************************** CAMPO DE TEXTO **************************************************** */}
          <Panel
            bordered
            header={<Text weight="semibold">Análisis de Evolución</Text>}
          >
            <div className="row mb-3">
              <div className="col-lg-6 col-md-6 col-sm-6 uppercase">
                <TextArea
                  variant="underlined"
                  rows={4}
                  readOnly
                  className="uppercase"
                  value={textoAnterior}
                />
                <span>
                  <Text weight="semibold">Nota de evolución anterior: {fecha}</Text>
                </span>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 uppercase">
                <TextArea
                  variant="underlined"
                  rows={4}
                  value={texto}
                  style={{ textTransform: "uppercase" }}
                  onChange={(e) => setTexto(e.target.value)}
                />
                <span>
                  <Text weight="semibold">Campo de análisis actúal</Text>
                </span>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6"></div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <Button
                  onClick={escuchando ? detenerEscucha : iniciarEscucha}
                  style={{
                    padding: "10px 20px",
                    backgroundColor: escuchando ? "red" : "green",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  icon={<LucideMic size={16}></LucideMic>}
                ></Button>
                <span>
                  <p>Estado: {escuchando ? "Escuchando..." : "Inactivo"}</p>
                </span>
              </div>
              <div className="text-end col-lg-4 col-md-4 col-sm-4">
                <Button
                  type="primary"
                  icon={<LucideSave size={16}></LucideSave>}
                  block
                  onClick={handleSendData}
                >
                  Guardar
                </Button>
              </div>
            </div>
          </Panel>

          <br></br>

          {/* *********************************************** DATOS DE LA CONSULTA ********************************************* */}
          <Panel
            collapsible
            bordered
            header={<Text weight="semibold">Datos de la Consulta</Text>}
          >
            <div className="row mb-2">
              <div className="col-lg-4 col-md-4 col-sm-4">
                <TextArea
                  variant="underlined"
                  rows={4}
                  readOnly
                  value={diagnostico}
                />
                <span>
                  <Text weight="semibold">Diagnostico</Text>
                </span>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4">
                <TextArea
                  variant="underlined"
                  rows={4}
                  readOnly
                  value={tratamiento}
                />
                <span>
                  <Text weight="semibold">Tratamiento</Text>
                </span>
              </div>
            </div>
          </Panel>

          <br></br>

          {/* *********************************************** EXPLORACION FISICA ************************************************ */}
          <Panel
            collapsible
            bordered
            header={
              <Text weight="semibold">Signos Vitales y Exploración Física</Text>
            }
          >
            <div className="row mb-2">
              <div className="text-center col-lg-1 col-md-1 col-sm-1">
                <Text size="sm">Peso</Text>
                <Input
                  style={{ textAlign: "center" }}
                  value={pesoEx}
                  readOnly
                />
              </div>
              <div className="text-center col-lg-1 col-md-1 col-sm-1">
                <Text size="sm">Talla</Text>
                <Input
                  style={{ textAlign: "center" }}
                  value={tallaEx}
                  readOnly
                />
              </div>
              <div className="text-center col-lg-1 col-md-1 col-sm-1">
                <Text size="sm">IMC</Text>
                <Input style={{ textAlign: "center" }} value={imcEx} readOnly />
              </div>
              <div className="text-center col-lg-1 col-md-1 col-sm-1">
                <Text size="sm" title="Presión arterial">
                  TA
                </Text>
                <Input
                  style={{ textAlign: "center" }}
                  value={presionArtEx}
                  readOnly
                />
              </div>
              <div className="text-center col-lg-1 col-md-1 col-sm-1">
                <Text size="sm" title="Frec. Cardiaca">
                  FC
                </Text>
                <Input
                  style={{ textAlign: "center" }}
                  value={frecCardiacaEx}
                  readOnly
                />
              </div>
              <div className="text-center col-lg-1 col-md-1 col-sm-1">
                <Text size="sm" title="Frec. Respiratoria">
                  FR
                </Text>
                <Input
                  style={{ textAlign: "center" }}
                  value={frecRespEx}
                  readOnly
                />
              </div>
              <div className="text-center col-lg-1 col-md-1 col-sm-1">
                <Text size="sm" title="Temperatura">
                  <b>T</b>emperatura
                </Text>
                <Input
                  style={{ textAlign: "center" }}
                  value={tempEx}
                  readOnly
                />
              </div>
              <div className="text-center col-lg-1 col-md-1 col-sm-1">
                <Text size="sm" title="Saturación de O2">
                  Sp<b>O</b>2
                </Text>
                <Input
                  style={{ textAlign: "center" }}
                  value={saturaOxEx}
                  readOnly
                />
              </div>
              <div className="text-center col-lg-1 col-md-1 col-sm-1">
                <Text size="sm">Glicemia capilar</Text>
                <Input
                  style={{ textAlign: "center" }}
                  value={glicemiaCapEx}
                  readOnly
                />
              </div>
              <div className="col-lg-3 col-md-3 col-sm-3">
                <Text size="sm">Otros datos</Text>
                <Input
                  as="textarea"
                  placeholder="Generales de la exploración..."
                  rows={3}
                  value={otrosDatosExploraEx}
                  readOnly
                />
              </div>
            </div>
            {dataSignosEx.length > 0 ? (
              <div className="row mb-2">
                <div className="col-lg-3 col-md-3 col-sm-3">
                  <Card key={`card1-Ex`}>
                    <Card.Header
                      style={{ fontSize: "12px" }}
                      key={`cardHeader-1-Ex`}
                    >
                      <b>{dataSignosEx[0].nombre}</b>
                    </Card.Header>
                    <Card.Body key={`cardBody-1-Ex`}>
                      <Textarea
                        key={`gpo1-Ex`}
                        rows={4}
                        readOnly
                        value={dataSignosEx[0].items[0]}
                      />
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3">
                  <Card key={`card2-Ex`}>
                    <Card.Header
                      style={{ fontSize: "12px" }}
                      key={`cardHeader-2-Ex`}
                    >
                      <b>{dataSignosEx[1].nombre}</b>
                    </Card.Header>
                    <Card.Body key={`cardBody-2-Ex`}>
                      <Textarea
                        key={`gpo2-Ex`}
                        rows={4}
                        readOnly
                        value={dataSignosEx[1].items[0]}
                      />
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3">
                  <Card key={`card-3-Ex`}>
                    <Card.Header
                      style={{ fontSize: "12px" }}
                      key={`cardHeader-3-Ex`}
                    >
                      <b>{dataSignosEx[2].nombre}</b>
                    </Card.Header>
                    <Card.Body key={`cardBody-3-Ex`}>
                      <Textarea
                        key={`gpo3-Ex`}
                        rows={4}
                        readOnly
                        value={dataSignosEx[2].items[0]}
                      />
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3">
                  <Card key={`card-4-Ex`}>
                    <Card.Header
                      style={{ fontSize: "12px" }}
                      key={`cardHeader-4-Ex`}
                    >
                      <b>{dataSignosEx[3].nombre}</b>
                    </Card.Header>
                    <Card.Body key={`cardBody-4-Ex`}>
                      <Textarea
                        key={`gpo4-Ex`}
                        rows={4}
                        readOnly
                        value={dataSignosEx[3].items[0]}
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
            ) : (
              ""
            )}
          </Panel>
          <br></br>
          <Panel
            bordered
            collapsible
            header={<Text weight="semibold">Antecedentes</Text>}
          >
            <div className="row mb-2">
              <div className="col">
                {listaAnteced.length > 0
                  ? listaAnteced.map((itm, index) => {
                      return (
                        <div key={`div-${index}`}>
                          <Accordion.Panel
                            header={`${itm.nombre}`}
                            bordered
                            defaultExpanded={false}
                            eventKey={2}
                            key={`accord-${index}`}
                          >
                            <table
                              className="w-full text-left text-sm text-gray-600"
                              key={`tbl-index-${index}`}
                            >
                              <thead
                                className="bg-gray-100 text-xs uppercase text-gray-700"
                                key={`thead-${index}`}
                              >
                                <tr
                                  key={`fila-${index}`}
                                  style={{
                                    borderBottom: "solid 2px",
                                    paddingBottom: "15",
                                    height: "25px",
                                  }}
                                >
                                  <th
                                    key={`header0-${index}`}
                                    style={{
                                      textAlign: "center",
                                      width: "5%",
                                    }}
                                  >
                                    <b>#</b>
                                  </th>
                                  <th
                                    key={`header1-${index}`}
                                    style={{ width: "30%" }}
                                  >
                                    <b>Item</b>
                                  </th>
                                  <th
                                    key={`header2-${index}`}
                                    style={{
                                      width: "15%",
                                      textAlign: "center",
                                    }}
                                  >
                                    <b>Respuesta</b>
                                  </th>
                                  <th
                                    key={`header3-${index}`}
                                    style={{ width: "50%" }}
                                  >
                                    <b>Observaciones</b>
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white">
                                {itm.detalles.map((item, ix) => {
                                  return (
                                    <tr key={`fila-${ix}`} className="hover:bg-gray-50 transition-colors">
                                      <td
                                        key={`celda1-${ix}`}
                                        style={{ textAlign: "center" }}
                                      >
                                        {item.id}
                                      </td>
                                      <td key={`celda2${index}-${ix}`}>
                                        {item.Item}
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <select
                                          key={`select-${ix}`}
                                          style={{ border: "none" }}
                                          disabled
                                        >
                                          <option
                                            key={`opt-select-SinVal-${ix}-${index}`}
                                            value=""
                                            selected={
                                              item.valorado === ""
                                                ? true
                                                : false
                                            }
                                          ></option>
                                          <option
                                            key={`opt-select-SI-${ix}-${index}`}
                                            value="SI"
                                            selected={
                                              item.valorado === "SI"
                                                ? true
                                                : false
                                            }
                                          >
                                            SI
                                          </option>
                                          <option
                                            key={`opt-select-NO-${ix}-${index}`}
                                            value="NO"
                                            selected={
                                              item.valorado === "NO"
                                                ? true
                                                : false
                                            }
                                          >
                                            NO
                                          </option>
                                        </select>
                                      </td>
                                      <td key={`obs-${index}${ix}`}>
                                        <Textarea
                                          key={`txtarea-${ix}`}
                                          autosize
                                          readOnly
                                          size="sm"
                                          defaultValue={item.observacion}
                                          style={{
                                            fontSize: "14px",
                                          }}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </Accordion.Panel>
                        </div>
                      );
                    })
                  : ""}
              </div>
            </div>
          </Panel>
        </Drawer.Body>
      </Drawer>
    </div>
  );
};
